import { render, staticRenderFns } from "./BtnAssinaturaPedido.vue?vue&type=template&id=583554db&"
import script from "./BtnAssinaturaPedido.vue?vue&type=script&lang=js&"
export * from "./BtnAssinaturaPedido.vue?vue&type=script&lang=js&"
import style0 from "./BtnAssinaturaPedido.vue?vue&type=style&index=0&id=583554db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports